import React from "react";
import { Navigate } from "react-router-dom";
import { useSurveyStatus } from "../../dashboard/hooks/useSurveyStatus";
import { getSurveyFlag } from "../../config/surveyFlags";

const SKIP_KEY = "onboarding_skipped";

export function skipOnboardingForSession() {
  sessionStorage.setItem(SKIP_KEY, "1");
}

export function RequireOnboarding({ children }) {
  const enabled = getSurveyFlag("surveys.onboarding_required");
  const { status, loading } = useSurveyStatus();

  if (!enabled) return children;
  if (loading) return null;
  if (sessionStorage.getItem(SKIP_KEY)) return children;
  if (status && !status.onboarding_completed) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
